<template lang="html">
  <tr class="wishlist-product-item">
    <td class="image">
      <a href="#!" class="product-image">
        <img :src="product.photo ||'/images/products/product_1.jpg'" alt="product img" width="75" />
      </a>
    </td>
    <td>
      <h3 class="product-name"><a href="#!">{{ product.Product_name }}</a></h3>
      <div class="description">
      {{ product.description }}
      </div>
      <!-- <textarea style="height: 120px; width: 90%;"></textarea> -->
    </td>
    <!-- <td class="hidden-table"></td>
    <td>
      <input value="1" size="4" class="input-text qty" maxlength="12" />
    </td> -->
    <td>
      <span class="cart-price">
        <span class="price">{{product.price}}</span>
      </span>
    </td>
    <td>
      <div class="cart-btn">
        <button type="button" class="button btn-cart" @click="addToShopCart(product)"></button>
      </div>
    </td>
    <td>
      <a href="#!" @click="deleteFromWishList" class="button remove-item"></a>
    </td>
  </tr>
</template>

<script>
import { mapMutations } from 'vuex';
import Swal from 'sweetalert2';
export default {
  mounted() {
    console.log(this.product);
  },
  computed:{
    api(){
      return this.$store.state.api;
    }
  },
  props:["product"],
  methods:{
    deleteFromWishList(){
      fetch(`${this.api}/client/wishlist`,{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("care_user_auth_token")
        },
        body: JSON.stringify({"product_id": this.product.id}),
      })
      .then(res => res.json())
      .then(data=>{
        console.log(data);
        this.$emit('removeItem', this.product.id)
      })
    },
    ...mapMutations(["addToCart"]),
    addToShopCart(){
      this.addToCart(this.product);
      Swal.fire({
        title: 'Success!',
        text: 'the product added to cart',
        icon: 'success',
        confirmButtonText: 'OK.'
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
